// 验证手机号码
export function validatePhoneNumber(phoneNumber: string) {
    const regex = /^1[3-578]\d{9}$/;
    return regex.test(phoneNumber);
}
// 验证验证码
export function validateCode(code:string) {
    const reg = /^\d{6}$/;
    return reg.test(code);
}